import { render, staticRenderFns } from "./CGV.vue?vue&type=template&id=11e3b074&scoped=true"
import script from "./CGV.vue?vue&type=script&lang=js"
export * from "./CGV.vue?vue&type=script&lang=js"
import style0 from "./CGV.vue?vue&type=style&index=0&id=11e3b074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e3b074",
  null
  
)

export default component.exports